import { render, staticRenderFns } from "./AlbumDetail.vue?vue&type=template&id=1fb81136&scoped=true"
import script from "./AlbumDetail.vue?vue&type=script&lang=js"
export * from "./AlbumDetail.vue?vue&type=script&lang=js"
import style0 from "./AlbumDetail.vue?vue&type=style&index=0&id=1fb81136&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb81136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb81136')) {
      api.createRecord('1fb81136', component.options)
    } else {
      api.reload('1fb81136', component.options)
    }
    module.hot.accept("./AlbumDetail.vue?vue&type=template&id=1fb81136&scoped=true", function () {
      api.rerender('1fb81136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/album/AlbumDetail.vue"
export default component.exports